import React from 'react';
import styles from "../../styles/metaai/MetaHistory.module.css";

const historyData = [
  {
    year: "2025",
    items: [
      { month: "12", text: "창업성장기술개발사업사업 최종보고서 발행" },
      { month: "10", text: "AI기반 감염병예측모델 구축컨설팅보고서 발행" },
      { month: "09", text: "㈜메타에이아이 ‘DocuMan’ 공인시험성적평가(TTA)" },
      { month: "07", text: "AI를 활용한 감염병예측모델 구축을 위한 컨설팅 계약(㈜위니텍) (사업기간 : 2025.7~ 2025.10)" },
      { month: "05", text: "검색데이터의 품질을 높인 RAG기반의 문서학습엔진 특허출원" },
      { month: "04", text: "서울벤처대학원대학교-인공지능기반 논문관리시스템 도입 컨설팅" },
      { month: "03", text: "‘예지보전-인공지능(AI)모델개발 계약 (㈜지엠에스아이엔씨) (개발기간 : 2025.3 ~ 2025.6)" },
    ],
  },
  {
    year: "2024",
    items: [
      { month: "10", text: "비에이케이터링㈜ 웹서비스 공급계약 체결" },
      { month: "09", text: "검색데이터의 품질을 높인 RAG기반의 문서학습엔진 개발 (창업성장기술개발사업, 중소기업기술정보진흥원)" },
      { month: "  ", text: "eXMC제품의 품질개선을 위한 기술지원 컨설팅 계약(㈜지엠에스아이엔씨)" },
      { month: "08", text: "리눅스 기반의 침입차단시스템(true EP) 개발 계약 체결(㈜트루컷시큐리티)" },
      { month: "06", text: "영남이공대학교 공학센터 IoT교육 공급계약 체결(2024년 운영)" },
      { month: "05", text: "명지전문대학(산학공동 기술개발과제 수주) [AI융합- 검색데이터의 품질을 높인 문서학습엔진 개발]" },
      { month: "02", text: "㈜엔씨엔스페이스 인공지능교육서비스 계약(개발직원대상 인공지능교육)" },
    ],
  },
  {
    year: "2023",
    items: [
      { month: "11", text: "ISO/IEC 17024 – AI지도사 양성과정 공동운영(국제AI교육원 상호협력 협정)" },
      { month: "09", text: "자체 R&D 모델 (생성형인공지능(AI.DocuMan)) 릴리즈(Release)" },
      { month: "07", text: "인더스트리4.0협회 스마트팩토리 인공지능교육 공급계약 체결(2023년 운영)" },
      { month: "06", text: "영남이공대학교 공학센터 IoT교육 공급계약 체결(2023년 운영)" },
      { month: "  ", text: "[미래신산업 수요특화형(AI/IoT)교육 위탁 운영(12개 대학)" },
      { month: "03", text: "SW사업자 인증 (한국SW산업협회)" },
      { month: "  ", text: "여수 · 순천 10 · 19사건 목록 관리시스템 유지보수 계약체결" },
      { month: "  ", text: "중소기업인증(중소벤처기업부장관)" },
      { month: "02", text: "스튜디오D코딩캠프 인공지능(영상처리) 교육 콘텐츠 공급계약" },
    ],
  },
  {
    year: "2022",
    items: [
      { month: "12", text: "명지전문대학 가족회사 협약" },
      { month: "11", text: "경민대학교 산학협력 협정" },
      { month: "  ", text: "영남이공대학교 가족회사 협약" },
      { month: "10", text: "명지전문대학(산학공동 기술개발과제 수주) [AI융합-인공지능 안전관리시스템 개발을 위한 데이터구축]" },
      { month: "08", text: "여수 · 순천 10 · 19사건 진상규명 D/B 목록 관리 프로그램 개발 용역 수주" },
      { month: "  ", text: "[클라우드(KT)기반 반응형웹서버 구축(여수·순천10·19사건진상규명및희생자명예회복위원회)]" },
      { month: "06", text: "영남이공대학교 공학센터 IoT교육 공급계약 체결(2022년 운영)" },
      { month: "  ", text: "[미래산업 수요특화형(AI/IoT)교육 위탁 운영 (11개 대학)]" },
      { month: "05", text: "서울벤처대학원대학교(SVU) 산학협력단 교육과정 공동운영 협정" },
      { month: "  ", text: "[디벨로퍼유니버시티(Developer University)-공동운영과정 교육브랜드 확정]" },
      { month: "02", text: "스튜디오D코딩캠프 교육협력협정(서울동부, 경기북부 교육센터 공동활용)" },
      { month: "  ", text: "[중등교육과정-인공지능&인공지능응용 교육과정 공동개발 및 운영" },
    ],
  },
  {
    year: "2021",
    items: [
      { month: "12", text: "서울서부교육센터 개원 [서울서부교육센터: 서울 강서구 공항대로 237, 1207호(마곡동, 에이스타워)]" },
      { month: "08", text: "영남이공대학교 공학센터 IoT교육 공급계약 체결(2021년 운영)" },
      { month: "  ", text: "[미래신산업수요특화형(AR/VR/IoT/3D프린팅)교육 위탁운영(9개 대학)]" },
      { month: "  ", text: "㈜건설인이인정받는사회(현장통) 협정 [인공지능기반의 안전관리시스템(SMS)개발 상호협력" },
      { month: "06", text: "주식회사 메타에이아이(MetaAI Corp.) 법인 설립" },
    ],
  },
];

const MetaHistory = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.heading}>연혁</h2>
          <p className={styles.sub}>2025년부터 2021년까지 연혁</p>
        </header>

        <div className={styles.timeline}>
          {/* {historyData.map((block) => (
            <div key={block.year} className={styles.yearBlock}>
              <div className={styles.year}>{block.year}</div>
              <div className={styles.yearStart}></div>
              <div className={styles.items}>
                {block.items.map((item, i) => (
                  <div key={i} className={styles.item}>
                    <div className={styles.month}>{item.month}</div>
                    <div className={styles.content}>{item.text}</div>
                  </div>
                ))}
              </div>
            </div>
          ))} */}
          {historyData.map((block) => (
            <div key={block.year} className={styles.yearBlock}>
              <div className={styles.yearCol}>
                <div className={styles.year}>{block.year}</div>
              </div>

              <div className={styles.blockBody}>
                <div className={styles.yearStart} />
                <div className={styles.items}>
                  {block.items.map((item, i) => (
                    <div key={i} className={styles.item}>
                      <div className={styles.month}>{item.month}</div>
                      <div className={styles.content}>{item.text}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MetaHistory